export default __webpack_public_path__ + "static/media/logo.30cf0de5.png";